// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IQuestionResponse
 */
export interface IQuestionResponse {
    /**
     * 
     * @type {string}
     * @memberof IQuestionResponse
     */
    prompt?: string;
    /**
     * 
     * @type {string}
     * @memberof IQuestionResponse
     */
    type?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof IQuestionResponse
     */
    answer?: Array<string>;
}

/**
 * Check if a given object implements the IQuestionResponse interface.
 */
export function instanceOfIQuestionResponse(value: object): value is IQuestionResponse {
    return true;
}

export function IQuestionResponseFromJSON(json: any): IQuestionResponse {
    return IQuestionResponseFromJSONTyped(json, false);
}

export function IQuestionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IQuestionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'prompt': json['prompt'] == null ? undefined : json['prompt'],
        'type': json['type'] == null ? undefined : json['type'],
        'answer': json['answer'] == null ? undefined : json['answer'],
    };
}

export function IQuestionResponseToJSON(json: any): IQuestionResponse {
    return IQuestionResponseToJSONTyped(json, false);
}

export function IQuestionResponseToJSONTyped(value?: IQuestionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'prompt': value['prompt'],
        'type': value['type'],
        'answer': value['answer'],
    };
}

